export const messages = {
  en: {
    communityPublicityManage: {
      page: {
        title: 'Community Publicity',
        subtitle: 'Publicity notices published to residents of the current community',
        empty: 'No publicity records',
        loadFailed: 'Failed to load publicity list, please retry',
        tip: 'Publicity is grouped by type on the left; switching type refreshes the list'
      },
      searchTitle: 'Search Conditions',
      titlePlaceholder: 'Please enter publicity title',
      tableTitle: 'Community Publicity List',
      headerImg: 'Header Image',
      title: 'Publicity Title',
      pubType: 'Publicity Type',
      pubTypeList: 'Publicity Type',
      createTime: 'Publicity Time',
      publisher: 'Publisher',
      deleteTitle: 'Confirm Delete',
      deleteConfirm: 'Are you sure to delete this community publicity?',
      deleteSuccess: 'Delete successfully',
      deleteError: 'Delete failed'
    }
  },
  zh: {
    communityPublicityManage: {
      page: {
        title: '小区公示',
        subtitle: '面向当前小区居民发布的公示公告',
        empty: '暂无公示记录',
        loadFailed: '公示列表加载失败，请重试',
        tip: '公示按类型分组在左侧展示，切换类型会自动刷新列表'
      },
      searchTitle: '查询条件',
      titlePlaceholder: '请输入公示标题',
      tableTitle: '小区公示列表',
      headerImg: '头部照片',
      title: '公示标题',
      pubType: '公示类型',
      pubTypeList: '公示类型',
      createTime: '公示时间',
      publisher: '发布人',
      deleteTitle: '确认删除',
      deleteConfirm: '确定要删除这条小区公示吗？',
      deleteSuccess: '删除成功',
      deleteError: '删除失败'
    }
  }
}
